import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmailDatum } from '../../../types/EmailDatum';

export const fetchEmailData = async (uuid?: string) => {
  if (!uuid) return undefined;

  const response = await CustomAxios.get<EmailDatum[]>(`email-data/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetEmailDataByIdProps {
  uuid?: string;
}

export function useGetEmailDataById({ uuid }: UseGetEmailDataByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allEmailData, uuid],
    queryFn: () => fetchEmailData(uuid)
  });

  return query;
}
